import { makeHttpClient, _unwrapAxiosResponse } from "./http";

import env from "../environment/env.json";

export interface UserResponse {
  id: number;
  name: string;
}

export class UserDataService {
  private httpClient = makeHttpClient();

  getAll(isExternal = false) {
    let url = `${env.userUrl}`;
    if (isExternal == true) {
      url = url + `?isExternal=${isExternal}`;
    }

    return _unwrapAxiosResponse(this.httpClient.get<Array<UserResponse>>(url));
  }
}

export default UserDataService;
